"use client";

import { datadogRum } from "@datadog/browser-rum";

if (process.env["NEXT_PUBLIC_VERCEL_ENV"] === "production") {
  datadogRum.init({
    applicationId: "c2f5ed75-ca0f-4194-884f-2cb59bb039ee",
    clientToken: "pubd4045714a73d50e4cc7bbecfc75e8e1a",
    site: "datadoghq.eu",
    service: "wayflyer-website",
    env: "prod",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    sessionPersistence: "local-storage",
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    allowedTracingUrls: ["https://wayflyer.com", "https://www.wayflyer.com"],
  });
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
